import { createAction, props } from '@ngrx/store';
import { AlarmManagementModel } from '@models/alarm-management.model';

export const resetToInitialState = createAction('[ALARM MANAGEMENTS] Reset to Initial state');

// Load Active Alarms
export const startGetActiveAlarms = createAction('[ALARM MANAGEMENTS] Start get active alarms');
export const getActiveAlarms = createAction('[ALARM MANAGEMENTS] Get active alarms');
export const getActiveAlarmsSuccess = createAction('[ALARM MANAGEMENTS] Get active alarms Success',
  props<{ activeAlarms: AlarmManagementModel.AlarmData[] }>()
);
export const getActiveAlarmsFail = createAction('[ALARM MANAGEMENTS] Get active alarms Fail');

// Load Canceled Alarms
export const startGetCanceledAlarms = createAction('[ALARM MANAGEMENTS] Start get canceled alarms');
export const getCanceledAlarms = createAction('[ALARM MANAGEMENTS] Get canceled alarms');
export const getCanceledAlarmsSuccess = createAction('[ALARM MANAGEMENTS] Get canceled alarms Success',
  props<{ canceledAlarms: AlarmManagementModel.AlarmData[] }>()
);
export const getCanceledAlarmsFail = createAction('[ALARM MANAGEMENTS] Get canceled alarms Fail');

// Load All Alarms with Filter
export const getAlarmHistory = createAction('[ALARM MANAGEMENTS] Get alarm history',
  props<{ filter?: AlarmManagementModel.AlarmFilter }>()
);
export const getAlarmHistorySuccess = createAction('[ALARM MANAGEMENTS] Get alarm history Success',
  props<{ alarms: AlarmManagementModel.AlarmData[] }>()
);
export const getAlarmHistoryFail = createAction('[ALARM MANAGEMENTS] Get alarm history Fail');

// Create Alarm
export const createAlarm = createAction('[ALARM MANAGEMENTS] Create alarm',
  props<{ createAlarm: AlarmManagementModel.CreateAlarm }>()
);
export const createAlarmSuccess = createAction('[ALARM MANAGEMENTS] Create alarm Success',
  props<{ alarmId: string }>()
);
export const createAlarmFail = createAction('[ALARM MANAGEMENTS] Create alarm Fail');

// Cancel Alarm
export const cancelAlarm = createAction('[ALARM MANAGEMENTS] Cancel alarm',
  props<{ alarmId: string}>()
);
export const cancelAlarmSuccess = createAction('[ALARM MANAGEMENTS] Cancel alarm Success');
export const cancelAlarmFail = createAction('[ALARM MANAGEMENTS] Cancel alarm Fail');

// Check Active Alarm for Location
export const checkActiveAlarm = createAction('[ALARM MANAGEMENTS] Check active alarm',
  props<{ locationId: string }>()
);
export const checkActiveAlarmSuccess = createAction('[ALARM MANAGEMENTS] Check active alarm Success',
  props<{ checkResult: AlarmManagementModel.AlarmCheckResponse }>()
);
export const checkActiveAlarmFail = createAction('[ALARM MANAGEMENTS] Check active alarm Fail');

// UI State
export const setAlarmsLoading = createAction('[ALARM MANAGEMENTS] Set Alarms Loading',
  props<{ isLoading: boolean }>()
);

export const setSelectedAlarm = createAction('[ALARM MANAGEMENTS] Set Selected Alarm',
  props<{ alarm: AlarmManagementModel.AlarmData | null }>()
);

export const setAlarmFilter = createAction('[ALARM MANAGEMENTS] Set Alarm Filter',
  props<{ filter: AlarmManagementModel.AlarmFilter }>()
);
